import React from 'react'
import pluralize from 'pluralize'
import classNames from 'classnames'

import { Button } from '@/components/buttons/Button'

export const BulkSelectBanner = ({
  handleBulkDeselect,
  handleSelectAll,
  selectedRows,
  searchFilteredRows,
  rows,
  rowsPerPage,
  bulkSelectAction,
  itemName = 'item',
  pagination,
  disabledSelection,
  dataGrid,
}) => {
  const allRowsSelected = selectedRows.length === rows.length
  const itemNamePlural = pluralize(itemName)

  return (
    <div className={classNames('bulk-select-banner', { 'data-grid-banner': dataGrid })}>
      <div className="flex-align-center medium-gap">
        <div>
          {allRowsSelected
            ? selectedRows.length === 1
              ? `All ${itemNamePlural} selected. `
              : `All ${selectedRows.length.toLocaleString()} ${itemNamePlural} selected. `
            : `${selectedRows.length.toLocaleString()} ${pluralize(itemName, selectedRows.length)} selected. `}

          {allRowsSelected && !disabledSelection && (
            <Button link data-testid="deselect-all-button" onClick={handleBulkDeselect}>
              {`Deselect all ${itemNamePlural}.`}
            </Button>
          )}

          {/* Theoretically, the selected rows might be the same length as the filteed rows if they do some shenanigans
        like selecting items before filtering, then deselecting some items after filtering, but it's unlikely enough that
        I didn't think it was necessary here to check all the item IDs in both lists and ensure they're the same. If something comes up,
        we can fix it.
         */}
          {!allRowsSelected &&
            !disabledSelection &&
            searchFilteredRows.length !== selectedRows.length && (
              <Button link data-testid="select-all-button" onClick={handleSelectAll}>
                {rows.length === searchFilteredRows.length
                  ? `Select all ${searchFilteredRows.length.toLocaleString()} ${itemNamePlural}${pagination ? ' across all pages' : ''}.`
                  : `Select matching ${searchFilteredRows.length.toLocaleString()} ${itemNamePlural}${pagination && rowsPerPage < searchFilteredRows.length ? ' across all pages' : ''}.`}
              </Button>
            )}
        </div>
      </div>
      {bulkSelectAction}
    </div>
  )
}
